var loadMoreAggregationOptions_gql_default = `
  query getMoreAggregationOptions($attributeCode: String!, $search: String = "", $filter: ProductAttributeFilterInput) {
    viewMoreFilter(filterName: $attributeCode, search: $search, filter: $filter) {
      aggregations {
        label
        count
        attribute_code
        frontend_input
        has_more
        options {
          count
          label
          value
          __typename
        }
        __typename
      }
      __typename
    }
  }
`;
export {
  loadMoreAggregationOptions_gql_default as default
};
